import { RectModule, ButtonModule, FitTextModule, FormFieldModule} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DoubleSchulteCorrectAnswerPreviewComponent } from './double-schulte-preview/double-schulte-answer-preview/double-schulte-answer-preview.component';
import { DoubleSchulteControllerComponent } from './double-schulte-controller/double-schulte-controller.component';
import { DoubleSchulteExamplePreviewComponent } from './double-schulte-preview/double-schulte-example-preview/double-schulte-example-preview.component';
import { DoubleSchulteParametersPreviewComponent } from './double-schulte-preview/double-schulte-parameters-preview/double-schulte-parameters-preview.component';
import { DoubleSchulteSettingsComponent } from './double-schulte-settings/double-schulte-settings.component';
import { DoubleSchulteUserAnswerPreviewComponent } from './double-schulte-preview/double-schulte-user-answer-preview/double-schulte-user-answer-preview.component';
import { TranslateModule } from '@ngx-translate/core';
import { AlphabetPickerModule } from '@shared/components/games/alphabet-picker/alphabet-picker.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';
import {MatTooltip} from "@angular/material/tooltip";

@NgModule({
  declarations: [
    DoubleSchulteControllerComponent,
    DoubleSchulteSettingsComponent,
    DoubleSchulteCorrectAnswerPreviewComponent,
    DoubleSchulteExamplePreviewComponent,
    DoubleSchulteParametersPreviewComponent,
    DoubleSchulteUserAnswerPreviewComponent,
  ],
  exports: [
    DoubleSchulteControllerComponent,
    DoubleSchulteSettingsComponent,
    DoubleSchulteCorrectAnswerPreviewComponent,
    DoubleSchulteExamplePreviewComponent,
    DoubleSchulteParametersPreviewComponent,
    DoubleSchulteUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      isolate: true,
    }),
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RectModule,
    FitTextModule,
    AlphabetPickerModule,
    GamesSharedModule,
    DimensionsListenerDirective,
    FormFieldModule,
    MatTooltip,
  ],
})
export class DoubleSchulteModule {}
